import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AuditScoreRow } from "../../models/lab-audit.models";

@Component({
  selector: "app-audit-score-summary",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./audit-score-summary.component.html",
  styleUrl: "./audit-score-summary.component.css",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuditScoreSummaryComponent {
  @Input({ required: true }) rows: AuditScoreRow[] = [];
}
